import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
    templateUrl: './negative-feedback-dialog.component.html',
    styleUrls: ['./negative-feedback-dialog.component.scss'],
    standalone: false
})
export class NegativeFeedbackDialogComponent implements OnInit {
  options = [`It does not work`, `It is slow`, `It is not clear`];

  constructor(private ref: MatDialogRef<NegativeFeedbackDialogComponent, string[] | null>) {}

  ngOnInit(): void {}

  static open(dialog: MatDialog) {
    return dialog.open<NegativeFeedbackDialogComponent, void, string[] | null>(NegativeFeedbackDialogComponent, {
      closeOnNavigation: true,
    });
  }

  sendFeedback(feedback: { options: number[]; otherIssue: string }) {
    const issues = [...(feedback.options || []).map(i => this.options[i]), feedback.otherIssue || '(issue details left empty)'];
    this.ref.close(issues);
  }
}
